export default function setCurrentUser(state, action) {
    const currentUser =  action.uuid;
    const currentUserEmail =  action.email;

    return {...state, currentUserEmail, currentUser};
}